import _regenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import { login, getInfo, logout, loginByWxWork } from '@/api/login';
import { getToken, setToken, removeToken } from '@/utils/auth';
import { resetUserStatus } from '@/api/dataCenter/onlineStatus';
import { handupCall } from '@/layout/components/phoneCall';
var getUserInfo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return getInfo();
        case 1:
          return _context.a(2, _context.v);
      }
    }, _callee);
  }));
  return function getUserInfo() {
    return _ref.apply(this, arguments);
  };
}();
var user = {
  state: {
    token: getToken(),
    user: {},
    roles: [],
    // 第一次加载菜单时用到
    loadMenus: false,
    clocks: [],
    system: [],
    // 看是否能跳转CMS系统
    call: {
      cId: undefined,
      phone: ''
    }
  },
  mutations: {
    SET_TOKEN: function SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_USER: function SET_USER(state, user) {
      state.user = user;
    },
    SET_ROLES: function SET_ROLES(state, roles) {
      state.roles = roles;
    },
    SET_LOAD_MENUS: function SET_LOAD_MENUS(state, loadMenus) {
      state.loadMenus = loadMenus;
    },
    SET_CLOCKS: function SET_CLOCKS(state, clocks) {
      state.clocks = clocks;
    },
    SET_SYSTEM: function SET_SYSTEM(state, system) {
      state.system = system;
    },
    SET_CALL: function SET_CALL(state, call) {
      state.call = call;
    }
  },
  actions: {
    // 登录
    Login: function Login(_ref2, userInfo) {
      var commit = _ref2.commit;
      if (userInfo.username) {
        // 账号密码登录
        var rememberMe = userInfo.rememberMe;
        return new Promise(function (resolve, reject) {
          login(userInfo.username, userInfo.password, userInfo.code, userInfo.uuid).then(/*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
              var result, _t;
              return _regenerator().w(function (_context2) {
                while (1) switch (_context2.n) {
                  case 0:
                    setToken(res.token, rememberMe);
                    commit('SET_TOKEN', res.token);
                    _t = setUserInfo;
                    _context2.n = 1;
                    return getUserInfo();
                  case 1:
                    result = _t(_context2.v, commit);
                    // 第一次加载菜单时用到， 具体见 src 目录下的 permission.js
                    commit('SET_LOAD_MENUS', true);
                    onlineStatusAfterLogin();
                    resolve(result);
                  case 2:
                    return _context2.a(2);
                }
              }, _callee2);
            }));
            return function (_x) {
              return _ref3.apply(this, arguments);
            };
          }()).catch(function (error) {
            reject(error);
          });
        });
      } else {
        // 企业微信登录
        return new Promise(function (resolve, reject) {
          loginByWxWork(userInfo).then(/*#__PURE__*/function () {
            var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(res) {
              var token, system, result, _t2;
              return _regenerator().w(function (_context3) {
                while (1) switch (_context3.n) {
                  case 0:
                    token = res.token, system = res.system;
                    setToken(token, false);
                    // 缓存token信息
                    commit('SET_TOKEN', token);
                    commit('SET_SYSTEM', system);
                    _t2 = setUserInfo;
                    _context3.n = 1;
                    return getUserInfo();
                  case 1:
                    result = _t2(_context3.v, commit);
                    // 第一次加载菜单时用到， 具体见 src 目录下的 permission.js
                    commit('SET_LOAD_MENUS', true);
                    onlineStatusAfterLogin();
                    resolve(result);
                  case 2:
                    return _context3.a(2);
                }
              }, _callee3);
            }));
            return function (_x2) {
              return _ref4.apply(this, arguments);
            };
          }()).catch(function (error) {
            reject(error);
          });
        });
      }
    },
    // 获取用户信息
    GetInfo: function GetInfo(_ref5) {
      var commit = _ref5.commit;
      return new Promise(function (resolve, reject) {
        getInfo().then(function (res) {
          setUserInfo(res, commit);
          resolve(res);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    // 登出
    LogOut: function LogOut(_ref6) {
      var commit = _ref6.commit;
      return new Promise(function (resolve, reject) {
        logout().then(function (res) {
          logOut(commit);
          resolve();
        }).catch(function (error) {
          logOut(commit);
          reject(error);
        });
      });
    },
    updateLoadMenus: function updateLoadMenus(_ref7) {
      var commit = _ref7.commit;
      return new Promise(function (resolve, reject) {
        commit('SET_LOAD_MENUS', false);
      });
    },
    // 企业微信侧边栏跳转过来
    redirectLogin: function redirectLogin(_ref8, token) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var commit, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              commit = _ref8.commit;
              setToken(token, false);
              // 缓存token信息
              commit('SET_TOKEN', token);
              _t3 = setUserInfo;
              _context4.n = 1;
              return getUserInfo();
            case 1:
              _t3(_context4.v, commit);
              // 第一次加载菜单时用到， 具体见 src 目录下的 permission.js
              commit('SET_LOAD_MENUS', true);
              onlineStatusAfterLogin();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    doCall: function doCall(_ref9, call) {
      var commit = _ref9.commit;
      commit('SET_CALL', call);
    },
    resetCall: function resetCall(_ref0) {
      var commit = _ref0.commit;
      commit('SET_CALL', {
        cId: undefined,
        phone: ''
      });
    }
  }
};
export var logOut = function logOut(commit) {
  commit('SET_TOKEN', '');
  commit('SET_ROLES', []);
  removeToken();
  handupCall();
};
export var setUserInfo = function setUserInfo(res, commit) {
  // 如果没有任何权限，则赋予一个默认的权限，避免请求死循环
  if (res.roles.length === 0) {
    commit('SET_ROLES', ['ROLE_SYSTEM_DEFAULT']);
  } else {
    commit('SET_ROLES', res.roles);
  }
  commit('SET_USER', res.user);
  var clocks = res.revisitReminderDtos.map(function (clock) {
    return {
      id: clock.id,
      customerId: clock.customerId,
      name: clock.customerSmallDto.name,
      phone: clock.customerSmallDto.phone,
      weChat: clock.customerSmallDto.wxchat,
      time: clock.time
    };
  });
  commit('SET_CLOCKS', clocks);
  return res;
};

/**
 * @description 登录后调的在线，刷新不走
 */
var onlineStatusAfterLogin = /*#__PURE__*/function () {
  var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          _context5.n = 1;
          return resetUserStatus();
        case 1:
          return _context5.a(2);
      }
    }, _callee5);
  }));
  return function onlineStatusAfterLogin() {
    return _ref1.apply(this, arguments);
  };
}();
export default user;